import { render, staticRenderFns } from "./informersList.vue?vue&type=template&id=f54adc7e&"
import script from "./informersList.vue?vue&type=script&lang=js&"
export * from "./informersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports